export default __webpack_public_path__ + "static/media/planpoint-unit-template.5caa353a.csv";